var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9182_2705)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36.1484,
    cy: 36.6133,
    r: 32,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9182_2705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.0661 29.8813V28.2672C42.0661 28.1193 41.9451 27.9982 41.7971 27.9982H28.8843C28.7363 27.9982 28.6152 28.1193 28.6152 28.2672V29.8813C28.6152 30.0293 28.7363 30.1503 28.8843 30.1503H41.7971C41.9451 30.1503 42.0661 30.0293 42.0661 29.8813ZM28.8843 32.8405C28.7363 32.8405 28.6152 32.9616 28.6152 33.1095V34.7236C28.6152 34.8716 28.7363 34.9927 28.8843 34.9927H35.0717C35.2196 34.9927 35.3407 34.8716 35.3407 34.7236V33.1095C35.3407 32.9616 35.2196 32.8405 35.0717 32.8405H28.8843ZM33.7266 48.04H25.9251V24.3665H44.7563V35.9342C44.7563 36.0822 44.8773 36.2032 45.0253 36.2032H46.9084C47.0564 36.2032 47.1774 36.0822 47.1774 35.9342V23.0214C47.1774 22.4262 46.6966 21.9453 46.1014 21.9453H24.58C23.9848 21.9453 23.5039 22.4262 23.5039 23.0214V49.3851C23.5039 49.9803 23.9848 50.4612 24.58 50.4612H33.7266C33.8745 50.4612 33.9956 50.3401 33.9956 50.1921V48.309C33.9956 48.1611 33.8745 48.04 33.7266 48.04ZM48.7142 49.7718L45.5768 46.6344C46.3267 45.6424 46.7739 44.4049 46.7739 43.0632C46.7739 39.7946 44.1241 37.1448 40.8555 37.1448C37.587 37.1448 34.9371 39.7946 34.9371 43.0632C34.9371 46.3317 37.587 48.9816 40.8555 48.9816C42.0594 48.9816 43.1758 48.6218 44.1106 48.0064L47.2951 51.1909C47.3489 51.2447 47.4162 51.2682 47.4834 51.2682C47.5507 51.2682 47.6213 51.2413 47.6718 51.1909L48.7142 50.1484C48.739 50.1237 48.7587 50.0944 48.7721 50.0621C48.7856 50.0298 48.7925 49.9951 48.7925 49.9601C48.7925 49.9251 48.7856 49.8905 48.7721 49.8582C48.7587 49.8258 48.739 49.7965 48.7142 49.7718V49.7718ZM40.8555 46.8294C38.774 46.8294 37.0893 45.1447 37.0893 43.0632C37.0893 40.9817 38.774 39.2969 40.8555 39.2969C42.9371 39.2969 44.6218 40.9817 44.6218 43.0632C44.6218 45.1447 42.9371 46.8294 40.8555 46.8294Z",
    fill: "#0297A8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9182_2705",
    x: 0.148438,
    y: 0.613281,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.576471 0 0 0 0 0.752941 0 0 0 0 0.231373 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9182_2705"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9182_2705",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9182_2705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.13,
    height: 30.13,
    fill: "white",
    transform: "translate(21.082 21.5469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.1f0d485b6921c946f3518c19917dc440.svg";
export { ForwardRef as ReactComponent };